module.exports = {
    Copyright:'Copyright © 2024',
    name:'View activity',
	settings:'Settings',
	Ranking:'Ranking',
	Questions:'Questions',
	Contents:'Contents',
	myAccount:'My Account',
	Edit:'Edit',
	Save:'Save',
	Member_since:'Member since',
	Last_login:'Last login',
	day:'Daily Package',
	week:'Weekly Package',
	Login:'Login',
  OTP:'OTP',
  Get:'Get',
  RESEND:'RESEND',
  codeTips1:'Please enter your phone number',
  codeTips2:'OTP is sent to your phone. Please check and enter.',
  codeTips3:'Please fill in the correct otp',
  loginCode:'Login/enter',
	phone_number:'Insert Mytel Phone Number',
	My_score:'My score',
	FAQs:'FAQs',
	T_C:'T&C',
	T_C2:'Terms of Use',
	Privacy_Policy:'privacy & policy',
	UNSUBSCRIBE:'UNSUBSCRIBE',
	Terms_of_Use:'True or false Terms of Use',
	no_data:'no data',
	Ranking_Score:'Ranking Score',
	Today:'Today',
	Week_Rank:'Weekly',
	Monthly:'Monthly',
	Question_List:'Questions',
	Question_ID:'Question ID',
	Question_Status:'Question Status',
	Questions_are_answered:'Questions are answered',
	Questions_are_not_answered:'Questions are not answered',
	Continue:'Continue',
	Get_more_questions:'Get more questions',
	Next:'Next',
	Submit:'Submit',
	Your_correct_answer_number_is:'Your correct answer number is',
	Your_total_score_is:'Your total score is',
	Review:'Review',
	cancel:'Cancel',
	Confirm:'Sure',
	No:'No',
	OK:'OK',
	Yes:'Yes',
	No_Question:'No Question',
	Back:'Back',
	Content_List:'Content List',
	Read_more:'Read more',
	more:'More',
	noMore:'No more',
	des:'Do you really want to unsubscribe True or false service?',
	des2:'Are you sure you want to unsubscribe?',
	tips:'Please enter phone number',
	tips2:'Operation Failed',
	msg2:'You are now going to purchase a new set of quizzes, you will be charge for 149ks per set of quizzes',
	msg1:'You have now finished playing 5 quests. Please purchase more tomorrow to continue playing.',
	loading:'loading',
	loadMore:'Pull up to load more',
	loadMore2:"It's over!",
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js